import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

    userRole: string;
    isLogin = false;
    roleAs: string;
    userData: any;

  constructor(private http: HttpClient) { }

  getMainData() {
      return this.http.get('agri/getCurrentUserInfo');
  }

    isLoggedIn() {
      return this.getMainData().subscribe(user => {
          this.userData = user;
          this.isLogin = true;
      }, error => {
          this.isLogin = false;
      });
    }

    getRole() {
        return this.getMainData().subscribe(user => {
            this.userData = user;
            this.roleAs = this.userData.roles;
        }, error => {
            this.roleAs = '';
        });
    }

}
